import ManageRelationshipForm from './ManageRelationshipForm';
import { useMatch, useNavigate, useParams } from 'react-router';

// A thin wrapper around the ManageRelationshipForm to set show in progress to true
const ManagePeerRelationshipForm = (props) => {
  // replicate what withReactRouter used to provide
  const match = useMatch('*');
  const params = useParams();
  const navigate = useNavigate();

  const history = {
    push: navigate,
  };

  return (
    <ManageRelationshipForm
      {...props}
      match={match}
      params={params}
      history={history}
      showInprogress={true}
      type="manage_other_relationships"
      location={props.location}
    />
  );
};

export default ManagePeerRelationshipForm;
